import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inputValue: '',
  progress: 0,
  images: [],
  suggestedSearch: [],
};

export const generationsSlice = createSlice({
  name: 'generations',
  initialState: { ...initialState },
  reducers: {
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setInputValue: (state, action) => {
      state.inputValue = action.payload;
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    setSuggestedSearch: (state, action) => {
      state.suggestedSearch = action.payload;
    },
  },
});

export const { setImages, setInputValue, setProgress, setSuggestedSearch } =
  generationsSlice.actions;
export default generationsSlice.reducer;
